module.exports = __webpack_public_path__ + "img/35712-036.94e99d2a.jpg";